/**
 * 国际化配置文件
 * SC:中文
 * TC:繁体
 */
export default {
    beQuerying: { SC: "查询中...", TC: "査詢中...", EN: "Searching..." },
    noneDate: { SC: "找不到符合条件记录.", TC: "找不到符合條件記錄.", EN: "No record is founed." },
    selectiveData: { SC: "请选择一条数据", TC: "請選擇一條數據", EN: "Please select a reord." },
    select: { SC: "Select", TC: "Select", EN: "Select" },
    cancel: { SC: "Cancel", TC: "Cancel", EN: "Cancel" },
    search: { SC: "Search", TC: "Search", EN: "Search" },
    reset: { SC: "Reset", TC: "Reset", EN: "Reset" },
}